<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-money-check-alt fa-fw" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <section v-if="!byName">
                <div class="tile-title" >R{{plan.id}}</div>
                <div class="meta mt-1"><i class="fas fa-money-check-alt mr-2 fa-fw"></i>{{plan.total | currency}} at {{plan.monthly | currency}}/mo for {{plan.term}} month<span v-if="plan.term !== 1">s</span></div>
                <div class="meta" v-if="plan.users"><i class="fas fa-user mr-2 fa-fw"></i>{{plan.users.first_name}} {{plan.users.last_name}}</div>
            </section>
            <section v-else>
                <div class="tile-title" >{{plan.users.last_name}}, {{plan.users.first_name}}</div>
                <div class="meta mt-1"><i class="fas fa-money-check-alt mr-2 fa-fw"></i>R{{plan.id}}</div>
                <div class="meta mb-1"><i class="fas mr-2 fa-fw"></i>{{plan.total | currency}} at {{plan.monthly | currency}}/mo for {{plan.term}} month<span v-if="plan.term !== 1">s</span></div>
            </section>

            <div
                class="meta mt-2 mb-2 has-text-warning"
                v-if="planStatus"
                style="margin-left: -10px;"
            >
                <b-tag :type="{'is-warning is-light': plan.is_default, 'is-danger is-light ': plan.is_collections, 'is-success is-light': (!plan.is_default && !plan.is_collections)}"><i class="fas fa-flag fa-fw mr-2"></i>{{ planStatus }}</b-tag>
            </div>
            <div class="meta mb-3" v-if="plan.is_tpo && plan.is_tpo_complete">
                <i class="fas fa-notes mr-2 fa-fw"></i>As of {{ plan.status_updated_at | moment('MMM Do, YYYY') }} ({{sinceStatusUpdate}} days ago)<span v-if="lastStatusUser"> by {{lastStatusUser}}</span>
            </div>

<!--            <div class="meta" v-if="plan.users"><i class="fas fa-at fa-fw mr-2"></i>{{plan.users.email}}</div>-->
            <div class="meta" v-if="!plan.is_tpo_complete && plan.portal_users"><i class="fas fa-user-tie fa-fw mr-2"></i>{{plan.portal_users.first_name}} {{plan.portal_users.last_name}}</div>
            <div class="meta mt-2" v-if="!plan.is_tpo_complete"><i class="fas fa-timer fa-fw mr-2"></i>{{plan.created_at | moment('MMMM Do YYYY')}} ({{daysOld}} days)</div>
            <div class="meta mt-2 has-text-warning" v-if="!plan.active && plan.inactive_reason"><i class="fas fa-snooze fa-fw mr-2"></i>{{plan.inactive_reason}}</div>
            <div class="meta mt-2 has-text-warning" v-if="!plan.is_collections && plan.is_error && plan.last_error_msg"><i class="fas fa-warning fa-fw mr-2"></i>{{plan.last_error_msg}}</div>
            <div class="meta mt-2 has-text-warning" v-if="!plan.is_collections && (plan.expected_paid - plan.paid) > 0"><i class="fas fa-bell-ring fa-fw mr-2"></i>{{ plan.expected_paid - plan.paid | currency }} past due.</div>
        </template>
        <template v-slot:status>
            <div class="stats">
                <b-tooltip v-if="plan.is_error" label="In Error State" position="is-left" class="stat mr-1"><i class="fas fa-warning has-text-warning"></i></b-tooltip>
                <b-tooltip v-if="plan.is_tpo_complete && !plan.active" label="Plan Suspended" position="is-left" class="stat mr-1"><i class="fas fa-snooze has-text-warning"></i></b-tooltip>
                <b-tooltip v-if="(plan.expected_paid - plan.paid) > 0" label="Past Due" position="is-left" class="stat mr-1"><i class="fas fa-bell-ring has-text-warning"></i></b-tooltip>
                <b-tooltip v-if="plan.is_default && !plan.is_collections" label="In Default" position="is-left" class="stat mr-1"><i class="fas fa-siren-on has-text-warning"></i></b-tooltip>
                <b-tooltip v-if="plan.is_collections" label="In Collections" position="is-left" class="stat mr-1"><i class="fas fa-gavel has-text-danger"></i></b-tooltip>
            </div>
        </template>
        <template v-slot:details>
            <div class="mt-3">
<!--                <toolbar class="toolbar">-->
<!--                    <button class="icon-only" @click.stop=""><i class="far fa-pencil"></i></button>-->
<!--                </toolbar>-->

                <div class="data mt-1">
                    <data-row mini title="Hours">{{plan.hours}}</data-row>
                    <data-row mini title="Total">{{plan.total | currency}}</data-row>
                    <data-row mini title="Term">{{plan.term}} months</data-row>
                    <data-row mini title="Monthly">{{plan.monthly | currency}}</data-row>
                    <data-row mini title="Paid">{{plan.paid | currency}}</data-row>
                    <data-row mini title="Defer">{{plan.defer_on | moment('MMMM Do YYYY')}}</data-row>
                    <data-row mini title="Created">{{plan.created_at | moment('MMMM Do YYYY, h:mm:ss a')}}</data-row>
                    <data-row mini title="ID">{{plan.id}}</data-row>
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "@/TIER/components/Toolbar";
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";
    import moment from "moment";
    import numeral from "numeral";

    export default {
        name: 'PlanTile',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            card: {
                required: true
            },
            plan: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            },
            byName: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                details: false
            }
        },
        computed: {
            daysOld: function () {
                return moment().diff(this.plan.created_at, 'days') + 1;
            },
            planStatus: function () {
                if (this.plan.status === 'active-reminder') return 'TPO Attempted Communication/Reminders';
                if (this.plan.status === 'active-arrangement') return 'User Made Arrangements';
                if (this.plan.status === 'active-courtesy') return 'TPO Provided Previous Courtesies';
                if (this.plan.status === 'active-pending') return 'Pending Default';
                if (this.plan.status === 'default-reminder') return 'TPO Attempted Communication/Reminders';
                if (this.plan.status === 'default-arrangement') return 'User Made Arrangements';
                if (this.plan.status === 'default-pending') return 'Pending Collections';
                if (this.plan.status === 'collections-ack') return 'In Collections (Acknowledged)';
                if (this.plan.status === 'collections-hold') return 'On Hold';
                if (this.plan.status === 'collections-info') return 'More Information is Needed (See Notes)';
                if (this.plan.status === 'collections-contact-attempt') return 'Attorney Attempted Communications';
                if (this.plan.status === 'collections-contact') return 'Attorney Made Contact';
                if (this.plan.status === 'collections-deadline') return 'Attorney Created Deadline for Resolution';
                if (this.plan.status === 'collections-neg-agreement') return 'Attorney Negotiated Agreement in Place (Settled)';
                if (this.plan.status === 'collections-neg-modification') return 'Attorney Negotiated Payment Modification (Settled)';
                if (this.plan.status === 'collections-payment') return 'Payment Received by Attorney (Settled)';
                if (this.plan.status === 'collections-payment') return 'Client is Paying Attorney (Settled)';
                if (this.plan.status === 'collections-garnishment') return 'Wage Garnishment in Place (Settled)';
                if (this.plan.status === 'collections-files') return 'Attorney Filed Lawsuit';
                if (this.plan.status === 'collections-summons') return 'Summons Served';
                if (this.plan.status === 'collections-court') return 'Attorney Set Court Date';
                if (this.plan.status === 'collections-ruling') return 'Attorney Acquired Ruling';
                if (this.plan.status === 'collections-other') return 'Other Status (See Notes)';
                return null;
            },
            sinceStatusUpdate: function () {
                return numeral(moment().diff(this.plan.status_updated_at, 'days')).format('0,0');
            },
            lastStatusUser: function() {
                if (!this.plan.payment_plan_notes || this.plan.payment_plan_notes.length === 0) return null;
                let lastStatus = this.plan.payment_plan_notes[0]
                return lastStatus.portal_users.first_name + ' ' + lastStatus.portal_users.last_name;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }
</style>
